import { jsx as _jsx } from "react/jsx-runtime";
import { LazyImageGallery } from "mazey-lazy-load-images";
import { openImageDetailDialog } from "../image-detail-dialog";
export function PhotoGallery({ items }) {
    if (items.length === 0) {
        return (_jsx("p", { className: "gallery-empty", children: "No photos yet. Add a dated album and run the photo organizer." }));
    }
    return (_jsx(LazyImageGallery, { items: items, minColumnWidth: "280px", gap: "16px", className: "photo-gallery", onImageClick: (context, event) => {
            const title = `${items[context.itemIndex].title.toUpperCase()}-${context.imageIndex + 1}`;
            openImageDetailDialog(context, event, title);
        } }));
}
